<!--  -->
<template>
	<div class="app">
		<Header></Header>
		<loginheader num="5" flagg="1"></loginheader>
		<div class="body">
			<div class="body-left">
				<Reconmment :recommend="datalist.hotAttr"></Reconmment>
				<div class="body-article-list">
					<informItem v-for="(item,index ) in cateAttr" :item="item" :key="index"></informItem>
				</div>
				<publicpaging :total="page.total" pagesize="6"></publicpaging>
			</div>
			<div class="body-right">
				<div class="body-right-col1">
					<img :src="recom.logo" />
					<div>{{recom.title}}</div>
				</div>
				<div style="display:flex;flex-direction: row;margin:22px 0 16px">
					<div style="width: 6px;height: 20px;background: #365ad2;border-radius: 3px;"></div>
					<div style="  font-size: 20px;line-height: 20px;margin-left: 12px;">七日热门</div>
				</div>
				<sevenHot :sevenHot="datalist.cateHotAttr"></sevenHot>
			</div>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';
	import loginheader from "../loginheader.vue";
	import Fotter from "../Fotter.vue";
	import Header from "../Header.vue";
	import Reconmment from "../Recommend.vue";
	import informItem from "../informItem.vue";
	import Popular from "../Popular.vue";
	import sevenHot from "../sevenHot.vue";
	import publicpaging from "../publicpaging.vue";
	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {
			loginheader,
			Header,
			Fotter,
			Reconmment,
			informItem,
			sevenHot,
			publicpaging
		},
		data() {
			//这里存放数据
			return {
				datalist: "",
				cateAttr: "",
				recom: "",
				page: ""
			};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {
			getpagedata(page = 1, size = 6) {
				this.$http.get(`article/4?page=${page}&size=${size}`).then(res => {
					this.datalist = res.body.data;
					this.cateAttr = res.body.data.cateAttr.data;
					this.recom = res.body.data.recom;
				});
			}
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {},
		beforeCreate() {
			this.$http.get("article/4?page=1&size=6").then(res => {
				this.datalist = res.body.data;
				this.cateAttr = res.body.data.cateAttr.data;
				this.recom = res.body.data.recom;
				this.page = res.body.data.cateAttr;
			});
		}, //生命周期 - 创建之前
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style  scoped>
	.body-article-list {
		width: 890px;
		height: fit-content;
		min-height: 100px;
		border: 1px solid #cccccc;
		border-radius: 8px;
		margin: 20px 0;
	}
	.body {
		width: 1200px;
		margin: auto;
		padding-top: 20px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding-bottom: 40px;
	}
	.body-left {
		width: 890px;
	}
	.body-right {
		width: 290px;
	}
	.body-right-col1 {
		height: 300px;
		width: 300px;
		position: relative;
	}
	.body-right-col1 img {
		height: 270px;
		width: 300px;
		border-radius: 8px 8px 0px 0px;
	}
	.body-right-col1 div {
		height: 30px;
		width: 300px;
		position: absolute;
		bottom: 0;
		background-color: #747474;
		color: #ffffff;
		font-size: 16px;
		line-height: 30px;
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		border-radius: 0px 0px 8px 8px;
	}
</style>



// WEBPACK FOOTER //
// src/components/index/Exhibition.vue